import { useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CompareTable } from "@components/CompareTable";
import { useCompare } from "@lib/hooks";

function parsePair(value: string | undefined) {
  if (!value) return "";
  const parts = value.split("-vs-");
  if (parts.length === 2) {
    return `${parts[0]},${parts[1]}`;
  }
  return "";
}

export function ComparePage() {
  const { pair } = useParams();
  const [searchParams] = useSearchParams();
  const idsFromQuery = searchParams.get("ids") ?? parsePair(pair);
  const [ids, setIds] = useState(idsFromQuery);
  const navigate = useNavigate();

  const compareQuery = useCompare(ids);
  const valid = useMemo(() => ids.split(",").filter(Boolean).length === 2, [ids]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!valid) return;
    navigate(`/compare/${ids.split(",").join("-vs-")}`);
  };

  const overlap = compareQuery.data;

  return (
    <div className="page compare">
      <h1>Compare Products</h1>
      <form className="compare-form" onSubmit={handleSubmit}>
        <label>
          Two product slugs (comma separated)
          <input
            value={ids}
            onChange={(event) => setIds(event.target.value)}
            placeholder="phone-13,phone-14"
          />
        </label>
        <button type="submit" disabled={!valid}>
          Compare
        </button>
      </form>
      {compareQuery.isLoading ? <p>Loading comparison…</p> : null}
      {compareQuery.isError ? <p>Unable to compare these products yet.</p> : null}
      {overlap ? (
        <section className="compare-results">
          <CompareTable rows={overlap.rows} />
          <div className="overlap">
            <h3>Shared Pros</h3>
            {overlap.prosOverlap.length ? (
              <ul>
                {overlap.prosOverlap.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : (
              <p>No shared pros yet.</p>
            )}
            <h3>Shared Cons</h3>
            {overlap.consOverlap.length ? (
              <ul>
                {overlap.consOverlap.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : (
              <p>No shared cons yet.</p>
            )}
          </div>
        </section>
      ) : null}
    </div>
  );
}
